import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/capabilities', label: 'Capabilities' },
    { path: '/use-cases', label: 'Use Cases' },
    { path: '/about', label: 'About' },
    { path: '/case-studies', label: 'Case Studies' },
    { path: '/resources', label: 'Resources' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white/95 backdrop-blur-lg border-b border-gray-200' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <img 
            src="https://static.readdy.ai/image/fa77cf8cc3bbd77c4d454e1d51d6ad11/0a63fa4771cac11da61baf62adfa212d.png" 
            alt="FluxByte AI Logo" 
            className="h-16 w-auto object-cover"
            style={{ objectFit: 'cover', objectPosition: 'center', transform: 'scale(1.5)' }}
          />
          <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">FluxByte</span>
        </Link>
        
        <div className="hidden md:flex items-center gap-8">
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === item.path 
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent' 
                  : 'text-gray-600 hover:bg-gradient-to-r hover:from-blue-600 hover:to-purple-600 hover:bg-clip-text hover:text-transparent'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <Link 
          to="/contact"
          className="hidden md:block px-6 py-2.5 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full text-sm font-semibold text-white hover:shadow-lg hover:shadow-purple-500/50 transition-all cursor-pointer whitespace-nowrap"
        >
          Get Started
        </Link>
      </div>
    </nav>
  );
}
